module.exports = __webpack_public_path__ + "img/img32.b71f710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img32.png
// module id = 210
// module chunks = 0